/* Dog inputs only. A previous product recommendation is never a profile input. */
(function (root) {
  'use strict';
  const storageKey = 'andcharlie.pet.session.v1';
  function clean(value) {
    if (!value || typeof value !== 'object') return null;
    const result = {};
    for (const key of ['weightKg', 'lengthCm', 'chestCm', 'neckCm']) {
      if (value[key] == null) continue;
      if (typeof value[key] !== 'number' || !Number.isFinite(value[key]) || value[key] <= 0) return null;
      result[key] = value[key];
    }
    if (!result.weightKg || !['yes', 'no', 'unknown'].includes(value.shortBody)) return null;
    result.shortBody = value.shortBody;
    if (result.shortBody !== 'unknown') delete result.lengthCm;
    return result;
  }
  function read(storage, identity = 'guest') {
    try {
      const entry = JSON.parse(storage.getItem(storageKey));
      if (entry?.identity !== identity || entry.version !== 1) {
        storage.removeItem(storageKey);
        return null;
      }
      return clean(entry.profile);
    } catch (_) { return null; }
  }
  function write(storage, identity, profile) {
    const value = clean(profile);
    if (!value) return false;
    try {
      storage.setItem(storageKey, JSON.stringify({version: 1, identity, profile: value}));
      return true;
    } catch (_) { return false; }
  }
  function clear(storage) { try { storage.removeItem(storageKey); } catch (_) { /* Storage can be denied. */ } }
  const api = Object.freeze({clean, read, write, clear});
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AndCharliePetProfile = api;
})(typeof window === 'undefined' ? globalThis : window);
